import { render, staticRenderFns } from "./EventTabAgenda.vue?vue&type=template&id=e6cc6f24&scoped=true&"
import script from "./EventTabAgenda.vue?vue&type=script&lang=js&"
export * from "./EventTabAgenda.vue?vue&type=script&lang=js&"
import style0 from "./EventTabAgenda.vue?vue&type=style&index=0&id=e6cc6f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cc6f24",
  null
  
)

export default component.exports